import { render, staticRenderFns } from "./blogdetail.vue?vue&type=template&id=585e9d7d"
import script from "./blogdetail.vue?vue&type=script&lang=js"
export * from "./blogdetail.vue?vue&type=script&lang=js"
import style0 from "./blogdetail.vue?vue&type=style&index=0&id=585e9d7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports